import loadScript from "../js/scripts/loadScript";
import loadCSS from "../js/scripts/loadCSS";

export default function () {
    var photoComparators = document.querySelectorAll(".before-after:not(.inited)");

    if(photoComparators.length > 0 ) {
        if(photoComparators[0].classList.contains('inited')){
            return;
        }
        photoComparators[0].classList.add('inited')
        if ('IntersectionObserver' in window) {
            let target = photoComparators[0];
            if(target !== null){
                var io = new IntersectionObserver(
                    entries => {
                        if (entries[0].isIntersecting) {
                            initPhotoComparator();
                            io.unobserve(target)
                        }
                    },
                    {}
                );
                io.observe(target);
            } else {
                firePhotoComparator();
            }
        } else {
            initPhotoComparator();
        }
    }

    function initPhotoComparator() {
        let script = loadScript('assets/tv24/lib/jquery.twentytwenty.min.js');
        loadCSS('assets/tv24/stylesheets/twentytwenty.min.css');

        script.onload = function(){
            firePhotoComparator();
        }
    }

    function firePhotoComparator() {
        $(".before-after").twentytwenty();
    }
}